import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from '../components/Layout';

const AdvancedSearch = () => {
  const navigate = useNavigate();
  const [searchCriteria, setSearchCriteria] = useState({
    documentNumber: '',
    year: new Date().getFullYear(),
    nationalId: '',
    fullName: '',
    phone: '',
    gender: '',
    nationality: '',
    bloodType: '',
    dateFrom: '',
    dateTo: '',
    status: ''
  });

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchCriteria(prev => ({ ...prev, [name]: value }));
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setResults([]);

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL || 'http://localhost:5003/api'}/prenups/search`, {
        params: searchCriteria,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });

      if (response.data.success) {
        setResults(response.data.data);
        setSearched(true);
      }
    } catch (error) {
      console.error('Search error:', error);
      setError(error.response?.data?.message || 'حدث خطأ أثناء البحث');
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setSearchCriteria({
      documentNumber: '',
      year: new Date().getFullYear(),
      nationalId: '',
      fullName: '',
      phone: '',
      gender: '',
      nationality: '',
      bloodType: '',
      dateFrom: '',
      dateTo: '',
      status: ''
    });
    setResults([]);
    setSearched(false);
    setError('');
  };

  const handleViewDetails = (prenupId) => {
    navigate(`/my-prenups/${prenupId}`);
  };

  return (
    <Layout>
      <div className="advanced-search-container">
        <div className="search-header">
          <h2>البحث المتقدم</h2>
          <p>البحث في استمارات فحص المقبلين على الزواج</p>
        </div>

      <div className="search-form-container">
        <form onSubmit={handleSearch} className="search-form">
          <div className="form-section">
            <h3>معايير البحث</h3>
            
            <div className="form-row">
              <div className="form-group">
                <label>رقم المستند</label>
                <input
                  type="text"
                  name="documentNumber"
                  value={searchCriteria.documentNumber}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="مثل: 2024-00001234"
                />
              </div>

              <div className="form-group">
                <label>السنة</label>
                <select
                  name="year"
                  value={searchCriteria.year}
                  onChange={handleChange}
                  className="form-control"
                >
                  {[...Array(5)].map((_, i) => {
                    const year = new Date().getFullYear() - i;
                    return <option key={year} value={year}>{year}</option>;
                  })}
                </select>
              </div>

              <div className="form-group">
                <label>الرقم القومي</label>
                <input
                  type="text"
                  name="nationalId"
                  value={searchCriteria.nationalId}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="الرقم القومي"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>الاسم الكامل</label>
                <input
                  type="text"
                  name="fullName"
                  value={searchCriteria.fullName}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="الاسم الكامل"
                />
              </div>

              <div className="form-group">
                <label>رقم الهاتف</label>
                <input
                  type="text"
                  name="phone"
                  value={searchCriteria.phone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="رقم الهاتف"
                />
              </div>

              <div className="form-group">
                <label>النوع</label>
                <select
                  name="gender"
                  value={searchCriteria.gender}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">الكل</option>
                  <option value="M">ذكر</option>
                  <option value="F">أنثى</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>الجنسية</label>
                <select
                  name="nationality"
                  value={searchCriteria.nationality}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">الكل</option>
                  <option value="E">مصري</option>
                  <option value="N">غير مصري</option>
                </select>
              </div>

              <div className="form-group">
                <label>فصيلة الدم</label>
                <select
                  name="bloodType"
                  value={searchCriteria.bloodType}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">الكل</option>
                  <option value="1">A</option>
                  <option value="2">B</option>
                  <option value="3">AB</option>
                  <option value="4">O</option>
                </select>
              </div>

              <div className="form-group">
                <label>الحالة</label>
                <select
                  name="status"
                  value={searchCriteria.status}
                  onChange={handleChange}
                  className="form-control"
                >
                  <option value="">الكل</option>
                  <option value="pending">قيد المراجعة</option>
                  <option value="approved">مقبول</option>
                  <option value="rejected">مرفوض</option>
                  <option value="printed">تم الطباعة</option>
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>من تاريخ</label>
                <input
                  type="date"
                  name="dateFrom"
                  value={searchCriteria.dateFrom}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>إلى تاريخ</label>
                <input
                  type="date"
                  name="dateTo"
                  value={searchCriteria.dateTo}
                  onChange={handleChange}
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'جاري البحث...' : 'بحث'}
            </button>
            <button type="button" className="btn btn-secondary" onClick={handleClear}>
              <>مسح</>
            </button>
          </div>
        </form>
      </div>

      {error && (
        <div className="alert alert-error">
          {error}
        </div>
      )}

      {searched && (
        <div className="search-results">
          <div className="results-header">
            <h3>نتائج البحث ({results.length})</h3>
          </div>

          {results.length === 0 ? (
            <div className="no-results">
              <p>لم يتم العثور على نتائج تطابق معايير البحث</p>
            </div>
          ) : (
            <div className="results-table-container">
              <table className="results-table">
                <thead>
                  <tr>
                    <th>رقم المستند</th>
                    <th>الاسم</th>
                    <th>النوع</th>
                    <th>الهاتف</th>
                    <th>تاريخ الإنشاء</th>
                    <th>الحالة</th>
                    <th>الإجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((prenup) => (
                    <tr key={prenup._id}>
                      <td>{prenup.documentNumber}</td>
                      <td>{`${prenup.FIRSTNAME} ${prenup.SECONDNAME} ${prenup.THIRDNAME}`}</td>
                      <td>{prenup.GENDER === 'M' ? 'ذكر' : 'أنثى'}</td>
                      <td>{prenup.PHONE}</td>
                      <td>{new Date(prenup.createdAt).toLocaleDateString('ar-EG')}</td>
                      <td>
                        <span className={`status-badge status-${prenup.status || 'pending'}`}>
                          {prenup.status === 'approved' ? 'مقبول' : 
                           prenup.status === 'rejected' ? 'مرفوض' :
                           prenup.status === 'printed' ? 'تم الطباعة' : 'قيد المراجعة'}
                        </span>
                      </td>
                      <td>
                        <button
                          className="btn btn-small btn-info"
                          onClick={() => handleViewDetails(prenup._id)}
                        >
                          عرض التفاصيل
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
      </div>
    </Layout>
  );
};

export default AdvancedSearch;